import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepagaComponent } from './prepaga.component';
import { PrepagaRoutingModule } from './prepaga-routing.module';
import { MaterialModule } from '../../../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    PrepagaComponent,
  ],
  imports: [
    CommonModule,
    PrepagaRoutingModule,
    MaterialModule,
    ReactiveFormsModule
  ]
})
export class PrepagaModule { }
